import { FC } from 'react';
import { FormLabel, InputAdornment, TextFieldProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { Iconify, RHFTextField } from '@app/components';

type FilePickerFieldProps = {
  name: string;
  label: string;
  multiple?: boolean;
  filePickerName?: string;
  accept?: string;
} & TextFieldProps;

const RHFFilePickerField: FC<FilePickerFieldProps> = ({
  name,
  label,
  multiple,
  filePickerName,
  accept,
  ...other
}) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <FormLabel
              className="file-field"
              htmlFor={`${name}-fileInput`}
              sx={{ display: 'flex', flexGrow: 1, cursor: 'pointer' }}
            >
              <RHFTextField
                name={name}
                label={label}
                value={field.value?.name || filePickerName}
                sx={{ pointerEvents: 'none' }}
                onChange={field.onChange}
                InputLabelProps={{ shrink: field.value }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Iconify icon="ep:upload-filled" />
                    </InputAdornment>
                  ),
                }}
                {...other}
              />
              <input
                type="file"
                id={`${name}-fileInput`}
                style={{ display: 'none' }}
                accept={accept}
                {...(multiple && { multiple: true })}
                onChange={(event) => {
                  const files = event?.target?.files;
                  if (files && files.length > 0) {
                    const file = files[0];
                    const newFile = Object.assign(file, {
                      preview: URL.createObjectURL(file),
                    });
                    field.onChange(newFile);
                  }
                }}
              />
            </FormLabel>
          );
        }}
      />
    </>
  );
};

export { RHFFilePickerField };
